<template>
  <div class="container-fluid">
    <div v-for="err in errors" :key="err.field" class="alert alert-danger">
      {{ err.value }}
    </div>
    <h4 class="m-3">Изменение слайда</h4>
    <el-form ref="form" :model="form" label-width="220px" id="uploadForm" name="uploadForm" enctype="multipart/form-data">
      <el-form-item label="Название">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Описание">
        <el-input type="textarea" v-model="form.description"></el-input>
      </el-form-item>
      <el-form-item label="Цвет текста">
        <el-color-picker v-model="form.textColor" size="large" />
      </el-form-item>
      <el-form-item label="Текст на кнопке">
        <el-input v-model="form.btnText"></el-input>
      </el-form-item>
      <el-form-item label="Цвет кнопки">
        <el-color-picker v-model="form.btnColor" size="large" />
      </el-form-item>
      <el-form-item label="Ссылка">
        <el-input v-model="form.link"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="form.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="form.activity"></el-checkbox>
      </el-form-item>
      <el-form-item label="Изображение">
        <el-upload action="" list-type="picture" :file-list="fileList" :limit="1" :auto-upload="false"
          :on-change="handleChange">
          <el-button size="small" type="primary">Добавить Изображение</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="Мобильное изображение">
        <el-upload action="" list-type="picture" :file-list="fileListMobile" :limit="1" :auto-upload="false"
          :on-change="handleChangeMobile">
          <el-button size="small" type="primary">Добавить Изображение</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="Тип объекта" placeholder="Выберите тип">
        <el-select v-model="form.mobileLink.type" @change="updatePayloadObject">
          <el-option v-for="it in typeObjects" :key="it.name" :value="it.name" :label="it.title" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.mobileLink.type" label="Идентификатор объекта" placeholder="Выберите тип">
        <el-button type="primary" size="small" @click="showDialog">
          Выбрать
        </el-button>
        <el-tag checked>Выбрано: {{ selectedItems.length }}</el-tag>
      </el-form-item>
      <el-form-item>


        <el-button type="primary" @click="storeMainSlide()">Изменить</el-button>
        <el-button @click="back">Отмена</el-button>
      </el-form-item>
    </el-form>
    <MainSlidesDialog v-if="$store.getters.showMainSlidesDialog" :type-item="form.mobileLink.type"
      :selected-props-items="selectedItems" @selectItem="onSelectItem" />
  </div>
</template>

<script>
import axios from "axios";
import getErrors from '../../composable/utils/getErrors';
import useFormData from '../../composable/useFormData'
import typeObjConfig from '../../composable/config/banner-type-object.config'
import getFileList from '../../composable/utils/getFileList'
import MainSlidesDialog from "./MainSlidesDialog.vue";

export default {
  components: {
    MainSlidesDialog,
  },
  name: "MainSlideUpdate",
  data: function () {
    return {
      typeObjConfig,
      form: {
        title: '',
        description: '',
        btnText: '',
        link: '',
        sort: 1,
        activity: true,
        image: '',
        mobileImage: '',
        textColor: '',
        btnColor: '',
        mobileLink: {
          type: '',
          payload: '',
        },
      },
      idSlide: this.$route.params.id,
      typeObjects: [],
      payloadObjects: [],
      isLoadPayloadObjects: false,
      selectedItems: [],
      errors: [],
      status: 0,
      fileList: [],
      fileListMobile: [],
    }
  },
  mounted() {
    this.getData()
      .then((response) => {
        const [slide, typeObjects] = response;
        this.typeObjects = typeObjects.data
        this.setForm(slide.data)
        this.setFileList(slide.data?.image || []);
        this.setFileListMobile(slide.data?.mobile_image || []);
      })
      .catch()
      .finally()
  },
  methods: {
    getData() {
      return Promise.all([
        axios.get(`/content/main-slide/${this.idSlide}`),
        axios.get("/content/main-slide/model-type/")
      ])
    },
    async updatePayloadObject() {
      try {
        this.isLoadPayloadObjects = true;
        this.selectedItems = [];
        this.setPayload();
      } catch (errors) {
        if (errors.response.status === 401) {
          this.$router.push('/login');
        } else if (errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        } else {
          this.setErrors([])
        }
      } finally {
        this.isLoadPayloadObjects = false;
      }
      return
    },
    back() {
      this.$router.push('/main-slides');
    },
    storeMainSlide() {
      const { execute } = useFormData();
      const data = execute().setFields([
        'image',
        'title',
        'description',
        'btnText',
        'link',
        'activity',
        'sort',
        'mobileLink',
        'mobileImage',
        'textColor',
        'btnColor',
      ]).getFormData(this.form)

      axios.post(`content/main-slide/${this.idSlide}`, data).then(() => {
        this.$router.push('/main-slides');
      }).catch((errors) => {

        if (errors.response.status === 401) {
          this.$router.push('/login');
        }
        if (errors.response.status === 422) {
          this.setErrors(errors.response.data.errors)
        }
      });
    },
    handleChange(v) {
      this.form.image = v?.raw || undefined
    },
    handleChangeMobile(v) {
      this.form.mobileImage = v?.raw || undefined
    },
    setErrors(err) {
      this.errors = getErrors(err)
    },
    setForm(value) {
      if (value) {
        this.form.title = value.title || '';
        this.form.description = value.description || '';
        this.form.btnText = value.btn_text || '';
        this.form.link = value.link || '';
        this.form.sort = value.sort || '';
        this.form.activity = value.activity || '';
        this.form.mobileLink.type = value.mobile_link?.type || '';
        this.form.mobileLink.payload = value.mobile_link?.payload || '';
        this.form.textColor = value.text_color || '';
        this.form.btnColor = value.btn_color || '';
        this.selectedItems = value.mobile_link?.payload ? [{ id: +value.mobile_link?.payload }] : [];
      }
    },
    setFileList(value) {
      this.fileList = getFileList(value)
    },
    setFileListMobile(value) {
      this.fileListMobile = getFileList(value)
    },
    async setPayload(payload) {
      if (payload) {
        this.form.mobileLink.payload = payload.id
      } else {
        this.form.mobileLink.payload = ""
      }
    },
    onSelectItem(v) {
      if (v) {
        this.selectedItems = [v];
        this.setPayload(v)
      } else {
        this.selectedItems = []
        this.setPayload()
      }
    },
    showDialog() {
      this.$store.commit('showMainSlidesDialog', true)
    }
  },
}
</script>